<template>
    <div class="row">
        <help-modal/>
        <div class="col-6">
            <div class="ibox form">
                <div class="ibox-title ibox-grey">
                    <h4>{{ __('new_message') }}</h4>
                    <div class="ibox-tools">
                        <button-open-help-modal :helpName="helpName" :inExtraDiv="false"/>
                    </div>
                </div>
                <div class="ibox-content">
                    <div class="row form-group">
                        <div class="col-12">
                            <b-form-group
                                :label="__('category') + '*'"
                                label-for="category"
                                :invalid-feedback="invalidFeedback('category')"
                                :state="checkState('category')"
                            >
                                <v-select
                                    v-model="selectedCategory"
                                    id="category"
                                    class="vue-select"
                                    :options="mappedCategories"
                                    :disabled="prefix === messageTypes.SUPER_ADMIN_COMMUNICATION || this.orderingServices"
                                    @input="categoryChangeHandler"
                                >
                                </v-select>
                            </b-form-group>
                        </div>

                        <div class="col-12">
                            <b-form-group
                                :label="__('message_recipient') + '*'"
                                label-for="users"
                                :invalid-feedback="invalidFeedback('users')"
                                :state="checkState('users')"
                            >
                                <v-select
                                    v-if="prefix !== messageTypes.CUSTOMER_SERVICE"
                                    v-model="selectedUser"
                                    id="users"
                                    class="vue-select"
                                    multiple
                                    :options="mappedUsers"
                                    :disabled=" !selectedCategory || selectedCategory.id !== privateCategoryType ">
                                <span slot="no-options">
                                    {{ __('message_no_options') }}
                              </span>

                                </v-select>
                                <v-select
                                  v-if="prefix === messageTypes.CUSTOMER_SERVICE"
                                    v-model="selectedUser"
                                    id="users"
                                    class="vue-select"
                                    multiple
                                    :options="mappedUsers"
                                >
                                </v-select>
                            </b-form-group>
                        </div>

                        <!-- message subject -->
                        <div class="col-12">
                            <b-form-group
                                :label="__('subject') + '*'"
                                label-for="subject"
                                :invalid-feedback="invalidFeedback('subject')"
                                :state="checkState('subject')"
                            >
                                <b-form-input id="subject" v-model="subject"/>
                            </b-form-group>
                        </div>

                        <!-- message body -->
                        <div class="col-12">
                            <b-form-group
                                :label="__('message') + '*'"
                                label-for="subject-input"
                                :invalid-feedback="invalidFeedback('body')"
                                :state="checkState('body')"
                            >
                                <textarea name="value" class="form-control communication-message-summernote" id="body"></textarea>
                            </b-form-group>
                        </div>

                        <div class="col-12">
                            <input type="checkbox" v-model="requireAnswer"/>
                            <label>{{ __('require_answer') }}</label>
                        </div>
                    </div>

                    <div class="form-group mt-2">
                        <label>{{ __('attachments') }}</label>
                    </div>

                    <!-- uploaded files wrapper-->
                    <div class="form-group row m-b-sm" v-for="(file, index) in files">
                        <div class="col">
                            <input type="text" class="form-control" :value="file.name" disabled>
                        </div>

                        <!-- delete attachment button -->
                        <div class="col-md-auto table-icons doc-service text-right">
                            <a @click="deleteAttachment(index)">
                                <i class="fa fa-trash pt-2"/>
                            </a>
                        </div>
                    </div>

                    <div class="row m-b">
                        <div class="col-md-12">
                            <input type="file" ref="file" style="display: none" @change="handleFileUploads">
                            <a @click="$refs.file.click()" class="btn btn-primary">
                                <i class="fa fa-plus"></i> {{ __('add_attachment') }}
                            </a>
                        </div>
                    </div>
                </div>
            </div>

            <div class="ibox">
                <div class="ibox-content">
                    <div class="row">
                        <div class="col-sm-4 col-sm-offset-2">
                            <a
                                :href="cancelUrl()"
                                class="btn btn-white btn-sm"
                            >
                                {{ __('cancel') }}
                            </a>
                            <button
                                class="btn btn-primary btn-sm"
                                @click="store"
                            >
                                {{ __('send') }}
                            </button>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import HelpModal from "../../../../components/help/HelpModal";
import ButtonOpenHelpModal from "../../../../components/help/ButtonOpenHelpModal";
import DecoupledEditor from '@ckeditor/ckeditor5-build-decoupled-document';
import '@ckeditor/ckeditor5-build-decoupled-document/build/translations/pl';
import $ from 'jquery';

export default {
    name: "Create",
    components: {
        HelpModal,
        ButtonOpenHelpModal
    },
    props: [
        'prefix',
        'categories',
        'messageTypes',
        'users',
        'privateCategoryType',
        'selectedClients',
        'orderServiceCategory'
    ],
    data() {
        return {
            helpName: "PMB-001",
            selectedCategory: [],
            selectedUser: [],
            subject: null,
            body: null,
            requireAnswer: false,
            files: [],
            errors: null,
            orderingServices : false,
            editor: DecoupledEditor,
            editorConfig: {
                language: 'pl',
                toolbar: {
                    items: [
                        'bold',
                        'italic',
                        'underline',
                        'removeFontStyle',
                        'fontSize',
                        'fontColor',
                        'alignment'
                    ]
                }
            }
        }
    },
    computed: {
        mappedUsers() {
        	if(this.prefix !== this.messageTypes.CUSTOMER_SERVICE) {
	            return this.users.map(user => {
	                return {
	                    id: user.id,
	                    label: user.name + " " + user.surname
	                }
	            });
            } else {
	             return this.users.map(user => {
	                return {
	                    id: user.id,
	                    label: user.name
	                }
	            });
            }
        },
        mappedCategories() {
            let mappedCategories = this.categories.map(category => {

                return {
                    id: category.id,
                    label: category.name,
                    is_from_sa: !!category.is_from_sa,
                    recivers:  category.recivers
                }
            });
            if(this.prefix !== this.messageTypes.CUSTOMER_SERVICE) {
                mappedCategories.unshift({
                   id: this.privateCategoryType,
                   label: this.__('private_message'),
                   is_from_sa: false
                });
            }
            return mappedCategories;
        }
    },
    methods: {
        onReady(editor) {
            editor.ui.getEditableElement().parentElement.insertBefore(
                editor.ui.view.toolbar.element,
                editor.ui.getEditableElement()
            );
        },
        categoryChangeHandler(event) {
            if (this.selectedCategory.id !== this.privateCategoryType) {
                this.selectedUser = this.selectedCategory.recivers;
                if (this.errors && this.errors.users) {
                    this.errors.users = null;
                }
            } else {
               this.selectedUser = [];
            }
        },
        store() {
            self = this;
            if(this.prefix == this.messageTypes.CUSTOMER_SERVICE) {
            	this.axios.post('/communication/message/super_admin_communication/listStore', this.prepareDataForStore())
                .then(response => {
                    toastr['success'](this.__(response.data.notification.message)).css('border', '0px');
                    if(self.selectedClients) {
                        window.location.href = '/customer-service/clients?filters_reset=true';
                    } else {
                        window.location.href = '/communication/message/super_admin_communication/0/listCoummunication';
                    }
                })
                .catch(error => {
                    this.errors = error.response.data.errors;
                });
            } else {
            	this.axios.post('/communication/message/' + this.prefix, this.prepareDataForStore())
                .then(response => {
                    toastr['success'](this.__(response.data.notification.message)).css('border', '0px');
                    window.location.href = '/communication/message/' + this.prefix + '/0/index';
                })
                .catch(error => {
                    this.errors = error.response.data.errors;
                });
            }
        },
        prepareDataForStore() {
            let formData = new FormData();

            formData.set('category', this.selectedCategory ? this.selectedCategory.id : '');
            formData.set('is_from_sa', this.selectedCategory.is_from_sa ? this.selectedCategory.is_from_sa : '');

            if (this.selectedUser.length) {
                if(typeof this.selectedUser !== 'string')
                {
                    this.selectedUser.forEach(user => {
                        formData.append('users[]', user.id);
                    });
                }
                else{
                    if(this.selectedUser == 'CONTsup'){
                        formData.append('users[]', 'CONTsup');
                    }
                }

            }

            formData.set('subject', this.subject ?? '');
            formData.set('body', $('#body').val() ?? '');
            formData.set('require_answer', this.requireAnswer ? this.requireAnswer : '');

            if (this.files.length) {
                this.files.forEach(file => {
                    formData.append('files[]', file);
                });
            }

            return formData;
        },
        invalidFeedback(type) {
            if (this.errors && this.errors[type]) {
                return this.errors[type][0];
            }
        },
        checkState(type) {
            return !(this.errors && this.errors[type]);
        },
        handleFileUploads(event) {
            this.files.push(...event.target.files);
            this.$refs.file.value = null;
        },
        deleteAttachment(index) {
            this.files.splice(index, 1);
        },
        cancelUrl() {
            if(this.orderingServices) {
                return '/application-settings';
            }
            if(this.selectedClients) {
                return '/customer-service/clients?filters_reset=true';
            }
            if(this.prefix == 'customer-service') {
                return '/communication/message/super_admin_communication/0/listCoummunication?filters_reset=true';
            }
            return '/communication/message/'+this.prefix+'/0/index?filters_reset=true';
        },
    },
    mounted() {
        {
            let urlParams = new URLSearchParams(window.location.search);
            if(urlParams.has('orderingServices')) {
               this.orderingServices = true;
               this.selectedUser = 'CONTsup';
            };
            self = this;
            if(this.selectedClients) {
                this.mappedUsers.forEach(function(v) {
                   if(self.selectedClients.includes(String(v.id))) {
                      self.selectedUser.push(v);
                   }
                });
            }

            if(this.orderingServices) {
                this.mappedCategories.forEach(function(v) {
                   if(v.id == self.orderServiceCategory) {
                      self.selectedCategory = v;
                   }
                });
            } else if (this.prefix === this.messageTypes.SUPER_ADMIN_COMMUNICATION) {
                this.selectedCategory = {
                    id: this.privateCategoryType,
                    label: this.__('private_message'),
                    is_from_sa: false
                }
            } else {
               this.selectedCategory = this.mappedCategories[0];
            }
            toggleLoader(false)
        }
    }
}
</script>

<style lang="scss">
.ck-editor__editable_inline {
    height: 150px !important;
    border: 1px #EBEBE4 solid !important;
}

.vue-select {
    .vs__dropdown-option--highlight {
        background: #16b394;
        color: white;
    }

    .vs__dropdown-option {
        padding: 10px;
    }

    .vs__dropdown-toggle {
        border-radius: unset;
        font-size: 11px;
        height: 31px;
    }

}
</style>
